import { IRouter } from '../type';
export const template: IRouter[] = [
  {
    path: '/template',
    name: 'template',
    meta: { title: '模板库（方正）', icon: 'el-icon-s-tools' },
    hidden: false, // 默认显示在菜单栏
    component: () => import('@/views/placeOrder/components/StudyStyleLibrary.vue')
  },
  {
    path: '/template_stu2tea',
    name: 'template_stu2tea',
    meta: { title: '模板库（学转教）', icon: 'el-icon-s-tools' },
    hidden: true, // 不显示在菜单栏
    component: () => import('@/views/placeOrder/components/FbdStyleLibrary.vue')
  },
];
